import { withVenmoRadioProps } from 'viewModel/checkout/sections/payment/section/venmoRadio/withVenmoRadioProps';
import PaymentRadio from 'components/RwdCheckout/Sections/Payment/Section/PaymentRadio';

export default withVenmoRadioProps(PaymentRadio);
